import type { RestaurantMenu } from '../../api/types'
import { pickReadableTextColor } from '../../lib/contrast'

interface Props {
  menu: Pick<RestaurantMenu, 'name' | 'logo' | 'primary_color'>
}

export function MenuHeader({ menu }: Props) {
  const textColor = pickReadableTextColor(menu.primary_color)

  return (
    <header
      className="w-full px-4 py-3 flex items-center gap-3"
      style={{ backgroundColor: menu.primary_color, color: textColor }}
    >
      {menu.logo ? (
        <img
          src={menu.logo}
          alt={`${menu.name} logo`}
          width={48}
          height={48}
          loading="lazy"
          className="h-12 w-12 object-contain shrink-0 rounded"
        />
      ) : (
        <div className="h-12 w-12 rounded bg-black/10 shrink-0" aria-hidden="true" />
      )}
      <h1 className="text-2xl font-bold font-heading leading-tight">{menu.name}</h1>
    </header>
  )
}
